/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';

import { useNaptime } from 'bundles/naptimejs';
import EnterpriseSocialProofMetrics from 'bundles/naptimejs/resources/enterpriseSocialProofMetrics.v1';

// i18n
import _t from 'i18n!nls/teams-v2';

type SocialProofPillProps = {
  teamCount: number;
};

export const SocialProofPill: React.FC<{}> = () => {
  const {
    data: { teamCount },
  } = useNaptime<SocialProofPillProps>(
    () => ({
      teamCount: EnterpriseSocialProofMetrics.numberRealActivePrograms(),
    }),
    // only want to call this once on mount, so pass in empty deps

    []
  );

  if (!teamCount) {
    return null;
  }

  const shouldFallback = teamCount < 2000;
  const message = shouldFallback ? (
    <FormattedMessage message={_t('Join thousands of teams learning on Coursera!')} />
  ) : (
    <FormattedMessage
      message={_t('Join {teamCount} teams learning on Coursera!')}
      teamCount={
        <strong>
          <FormattedNumber value={teamCount} />
        </strong>
      }
    />
  );

  // Overflow override is to ensure flex sizes the element properly.
  // Smaller viewports can truncate text is hidden
  return (
    <div
      css={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 32,
        padding: 'var(--cds-spacing-200)',
        borderRadius: 32,
        background: 'var(--cds-color-blue-50)',
        whiteSpace: 'nowrap',
      }}
    >
      <Typography2 variant="subtitleMedium" component="div">
        {message}
      </Typography2>
    </div>
  );
};

export default SocialProofPill;
